// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import xOrderInformationStyles from "@conklin/App/SharedStyles/MyAccountPages/Details/OrderInformationStyles";
import { rfqQuoteDetailsInformationStyles } from "@conklin/Overrides/Widgets/RfqQuoteDetails/RfqQuoteDetailsInformation";
import { fontConfig } from "@conklin/XDL/PreStyle/typography";
import { color, mergeWithCss, xScreen } from "@conklin/XDL/Utilities";
import { css } from "styled-components";

rfqQuoteDetailsInformationStyles.detailsGridContainer = {
    gap: 24,
    css: css`
        margin-bottom: 24px;
        padding-bottom: 24px;
        border-bottom: 1px solid ${color("common.border")};
    `,
};

rfqQuoteDetailsInformationStyles.expirationDateGridItem = {
    width: 12,
    css: css`
        flex-direction: column;
    `,
};

rfqQuoteDetailsInformationStyles.expirationDateDatePicker = {
    cssOverrides: {
        datePicker: css`
            width: 200px;
        `,
        formField: css`
            label {
                font-size: 14px;
                line-height: 17px;
                font-weight: bold;
                margin-right: 4px;
            }
        `,
    },
};

rfqQuoteDetailsInformationStyles.expirationDateTextGridItem = {
    width: [12, 12, 6, 4, 4],
    css: css`
        flex-direction: column;
    `,
};

rfqQuoteDetailsInformationStyles.expirationDateLabelText = {
    ...mergeWithCss(xOrderInformationStyles.label, {
        css: css`
            margin-bottom: 8px;
        `,
    }),
};

rfqQuoteDetailsInformationStyles.expirationDateValue = {
    ...xOrderInformationStyles.value,
};

rfqQuoteDetailsInformationStyles.headingAndTextData = {
    wrapper: {
        ...mergeWithCss(xOrderInformationStyles.headingAndTextStyles?.wrapper, {
            css: css`
                flex-direction: column;
            `,
        }),
    },
    heading: {
        ...xOrderInformationStyles.label,
    },
    text: {
        ...xOrderInformationStyles.value,
    },
};

rfqQuoteDetailsInformationStyles.jobNameGridItem = {
    width: [12, 12, 6, 4, 4],
};

rfqQuoteDetailsInformationStyles.salesRepGridItem = {
    width: [12, 12, 6, 4, 4],
};

rfqQuoteDetailsInformationStyles.userGridItem = {
    width: [12, 12, 6, 4, 4],
};

rfqQuoteDetailsInformationStyles.statusGridItem = {
    width: [12, 12, 6, 4, 4],
};

rfqQuoteDetailsInformationStyles.dateLabelText = {
    ...mergeWithCss(xOrderInformationStyles.label, {
        css: css`
            margin-bottom: 8px;
        `,
    }),
};

rfqQuoteDetailsInformationStyles.dateValue = {
    ...xOrderInformationStyles.value,
};

rfqQuoteDetailsInformationStyles.dateGridItem = {
    width: [12, 12, 6, 4, 4],
    css: css`
        flex-direction: column;
    `,
};

rfqQuoteDetailsInformationStyles.customerGridItem = {
    width: [12, 12, 6, 4, 4],
};

rfqQuoteDetailsInformationStyles.shipToGridItem = {
    width: [12, 12, 6, 4, 4],
};

rfqQuoteDetailsInformationStyles.notesGridItem = {
    width: 12,
};

rfqQuoteDetailsInformationStyles.notesHeadingAndText = {
    heading: {
        size: 14,
        lineHeight: "22px",
        weight: "bold",
        transform: "none",
        css: css`
            margin-right: 4px;
        `,
    },
    wrapper: {
        css: css`
            flex-direction: column;
        `,
    },
    text: {
        size: 14,
        lineHeight: "22px",
        css: css`
            &:empty:after {
                content: "- -";
            }
        `,
    },
};
